// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2leSM","tab":"Tabs_tab__1SNy7","tabActive":"Tabs_tabActive__A1oPh"};